<template>
  <div class="e-card">
    <a-tabs :default-active-key="1" @change="changeTab">
      <a-tab-pane :key="1" tab="中间带电子医疗卡">
        <div class="card">
          <div id="cardImg" class="preview-bg-item" :style="{ color: color }">
            <!-- 做背景生成图片会很糊 所以用图片定位在底部 -->
            <img :src="formData.imgUrl || bgUrl" crossOrigin="*" class="card-bg" width="330" />
            <div class="info">
              <p class="label-item">
                <span class="label-name">卡号</span>
                <span class="label-value">{{ formData.cardNo }}</span>
              </p>
              <p class="label-item">
                <span class="label-name">会员姓名</span>
                <span class="label-value">{{ formData.employeeName }}</span>
              </p>
              <p class="label-item">
                <span class="label-name">公司名称</span>
                <span class="label-value">{{ formData.corpName }}</span>
              </p>
              <p class="label-item label-item1">
                <span class="label-name">会员号</span>
                <span class="label-value">{{ formData.payorMemberId }}</span>
              </p>
              <p v-if="formData.planStartDt" class="label-item label-item1">
                <span class="label-name">生效日期</span>
                <span class="label-value"
                  >{{ formData.planStartDt.split(' ')[0]
                  }}{{
                    formData.planEndDt
                      ? `-${formData.planEndDt.split(' ')[0]}`
                      : ''
                  }}
                </span>
              </p>
            </div>
            <div class="code-img">
              <p>就诊时请向医院出示二维码</p>
              <div ref="qrCode" class="code-qr"></div>
            </div>
          </div>
        </div>
      </a-tab-pane>
      <a-tab-pane
        v-if="formData.uhcCardId"
        :key="2"
        tab="含美计划"
        force-render
      >
        <div class="uhc-card">
          <!-- 正面 -->
          <div id="uhcCardImg" class="top-content-div front-side">
            <div class="flex s-between">
              <img
                :src="require('@/assets/ecard/UHC-logo0.png')"
                alt=""
              />
              <img
                :src="require('@/assets/ecard/logo.png')"
                width="80"
                alt=""
              />
            </div>
            <div class="flex item-div">
              <div class="left-div">
                <div class="name_zh">Issuer（80840）:</div>
              </div>
              <div class="right-div">911-87601-04</div>
            </div>
            <div class="flex s-between">
              <div class="flex item-div">
                <div class="left-div">
                  <div class="name_zh">Member ID:</div>
                </div>
                <div class="right-div">{{ formData.uhcCardId }}</div>
              </div>
              <div class="flex item-div">
                <div class="left-div">
                  <div class="name_zh">Group Number:</div>
                </div>
                <div class="right-div">76-570055</div>
              </div>
            </div>
            <div class="divider"></div>
            <div class="flex s-between a-start">
              <div class="flex item-div">
                <div class="left-div">
                  <div class="name_zh">Member:</div>
                </div>
                <div class="right-div">{{ formData.empName }}</div>
              </div>
              <div class="rx-box">
                <img
                  :src="require('@/assets/ecard/UHC-logo1.png')"
                  width="60"
                  alt=""
                />
                <div class="flex item-div">
                  <div class="left-div">
                    <div class="name_zh">RX BIN:</div>
                  </div>
                  <div class="right-div">610127</div>
                </div>
                <div class="flex item-div">
                  <div class="left-div">
                    <div class="name_zh">RX PCN:</div>
                  </div>
                  <div class="right-div">1960000</div>
                </div>
                <div class="flex item-div">
                  <div class="left-div">
                    <div class="name_zh">RX GRP:</div>
                  </div>
                  <div class="right-div">01990012</div>
                </div>
              </div>
            </div>
            <div class="text-right">
              <img
                :src="require('@/assets/ecard/UHC-logo2.png')"
                alt=""
              />
              <p class="tel-tip">
                Provider: For effective date of coverage call 844-265-8328
              </p>
            </div>
          </div>
        </div>
      </a-tab-pane>
    </a-tabs>
  </div>
</template>

<script>
import html2canvas from 'html2canvas'
import QRCode from 'qrcodejs2'

export default {
  props: {
    formData: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      activeTab: 1,
      qrCode: null,
      bgUrl: require('@/assets/ecard/default_bg.jpg'),
      color: '#333'
    }
  },
  mounted() {
    console.log(this.formData, 'this.formData')
    this.bindQRCode()
  },
  methods: {
    changeTab(key) {
      this.activeTab = key
    },
    // 下载图片
    handleDownloadSubmit() {
      let id = ''
      id = this.activeTab === 1 ? 'cardImg' : 'uhcCardImg'
      // 生成海报
      const vm = this
      const domObj = document.getElementById(id)
      html2canvas(domObj, {
        useCORS: true,
        logging: false,
        scale: 2, //按比例增加分辨率 (2=双倍).
        onclone(doc) {
          let e = doc.querySelector('#' + id)
          e.style.display = 'block'
        }
      }).then(function (canvas) {
        // 在微信里,可长按保存或转发
        const img = canvas.toDataURL('image/png')
        // 下载图片
        const blobData = vm.dataURLtoBlob(img)
        const url = window.URL.createObjectURL(blobData)
        let link = document.createElement('a')
        link.setAttribute('href', url)
        link.setAttribute('download', vm.formData.cardNo)
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
      })
    },
    // 生成二维码
    bindQRCode() {
      if (this.qrCode) {
        return
      }
      this.qrCode = new QRCode(this.$refs.qrCode, {
        text: this.formData.cardNo + '',
        width: 250,
        height: 250,
        colorDark: '#333333',
        colorLight: '#ffffff',
        correctLevel: QRCode.CorrectLevel.L
      })
    },
    dataURLtoBlob(dataURL) {
      const arr = dataURL.split(',')
      const mime = arr[0].match(/:(.*?);/)[1]
      const bStr = atob(arr[1])
      let n = bStr.length
      const u8arr = new Uint8Array(n)
      while (n--) {
        u8arr[n] = bStr.charCodeAt(n)
      }
      return new Blob([u8arr], { type: mime })
    }
  }
}
</script>

<style lang="scss" scoped>
.flex {
  display: flex;
  justify-content:space-between
}
.preview-bg-item {
  width: 360px;
  height: 220px;
  margin: 0 auto;
  background-color: transparent;
  box-sizing: border-box;
  padding: 55px 16px 40px;
  position: relative;
  border-radius: 15px;
  .card-bg {
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    z-index: 0;
  }
  .info {
    position: relative;
    z-index: 2;
  }
  .label-item {
    font-weight: 500;
    margin-top: 2px;
    font-size: 12px;
    display: flex;
    align-items: baseline;
    &.label-item1 {
      width: calc(100% - 80px);
    }
    .label-name {
      width: 60px;
    }
    .label-value {
      flex: 1;
      word-break: break-all;
    }
  }
  .code-img {
    position: absolute;
    width: 80px;
    bottom: 5px;
    right: 5px;
    background-color: #fff;
    border-radius: 5px;
    p {
      font-size: 10px;
      padding: 2px 5px 0;
      color: #aaa;
      transform: scale(0.6);
      transform-origin: top left;
      word-break: normal;
      white-space: nowrap;
      margin-bottom: -10px;
    }
    /deep/.code-qr {
      img {
        width: 100%;
        padding: 5px;
      }
    }
  }
}

.uhc-card {
  width: 350px;
  height: 220px;
  margin: 0 auto;
  background-color: transparent;
  box-sizing: border-box;
  padding: 10px;
  position: relative;
  border-radius: 15px;
  .top-content-div {
    padding: 5px 10px 10px;
    border-radius: 15px;
    font-size: 10px;
    color: #000;
    &.front-side {
      background-image: url('../../assets/ecard/UHC-bg.jpg');
      background-repeat: no-repeat;
      background-size: 100% 100%;
      background-position: center center;
    }
    &.back-side {
      padding: 10px;
      background-color: #fff;
    }
    .name_zh {
      color: #1a3d8b !important;
    }
    .s-between {
      justify-content: space-between;
    }
    .a-start {
      align-items: flex-start;
    }
    img {
      max-width: 90px;
    }
    .item-div {
      // height: 20px;
      margin-bottom: 5px;
      .left-div {
        min-width: 56px;
        margin-right: 8px;
      }
    }
    .divider {
      width: 100%;
      height: 2px;
      margin: 3px 0 8px;
      background-color: #1a3d8b;
    }
    .rx-box {
      max-width: 120px;
      min-width: 100px;
      padding: 0 5px 5px;
      border: 1px solid #1a3d8b;
      font-size: 6px;
      .item-div {
        margin-top: 3px;
        margin-bottom: 0;
        .left-div {
          min-width: 18px;
        }
      }
    }
    .text-right {
      text-align: right;
    }
    .tel-tip {
      font-size: 6px;
      font-weight: bold;
    }
  }
  .back-side {
    .tips {
      font-size: 6px;
      color: #ccc;
      margin-bottom: 10px;
    }
    .mar-top5 {
      margin-top: 5px;
    }
    .mar-bottom30 {
      margin-bottom: 25px;
    }
    .divider {
      height: 1px;
      margin: 10px 0 5px;
      background-color: #ccc;
    }
    .bold-font {
      font-weight: bold;
    }
    .small-font {
      font-size: 6px;
      line-height: 1.2;
    }
    .mini-font {
      font-size: 6px;
      .left-div {
        min-width: 18px;
      }
    }
  }
}
</style>
